import { Sparkles, ShieldCheck, Zap, TrendingUp } from "lucide-react";
import SEO from "@/components/SEO";

const ITEMS = [
  { icon: Sparkles, title: "AI-powered strategist", desc: "Not just a dashboard — a consultant that reads the numbers, points to opportunities and recommends next steps." },
  { icon: TrendingUp, title: "Honest revenue math", desc: "Revenue estimates use realistic CPMs (low / mid / high) and the standard 55% creator share. No inflated numbers." },
  { icon: Zap, title: "Fast & professional", desc: "Smart caching, dense clean layouts, accurate charts. Built for creators, brands and agencies who work with YouTube every day." },
  { icon: ShieldCheck, title: "Ready to scale", desc: "The architecture is prepared to expand to Instagram, TikTok, Twitch and Kick with no rewrite required." },
];

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
      <SEO
        title="About Creator Intelligence Tube"
        description="Learn about Creator Intelligence Tube: the AI-powered YouTube analytics platform with complete statistics, estimated revenue and creator recommendations."
        path="/about"
      />
      <h1 className="text-5xl font-black tracking-tighter">About Creator Intelligence Tube</h1>
      <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
        The platform was built to answer a simple question: <span className="text-foreground font-semibold">&ldquo;what is this channel
        actually doing well — and what can it improve?&rdquo;</span> We analyze any public YouTube channel in seconds using the
        official YouTube Data API v3 and an AI consultant that interprets the data like a senior strategist.
      </p>
      <div className="mt-12 grid sm:grid-cols-2 gap-4">
        {ITEMS.map((it) => (
          <div key={it.title} className="card-flat p-6">
            <it.icon className="w-5 h-5 text-primary mb-3" />
            <div className="font-bold text-lg">{it.title}</div>
            <div className="mt-2 text-sm text-muted-foreground">{it.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
